










import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import NewsListItem from "../../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/NewsModels/NewsListItem";
@Component
export default class NewsImagePreviewComponent extends Vue {
  @Prop()
  news: NewsListItem;
}
